import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/** Prefix marking a synthetic pairing id assigned to players with no real US Chess ID. */
export const SYNTHETIC_USCF_PREFIX = 'NOUSCF-';

/** True when a US Chess ID value is actually a synthetic pairing placeholder. */
export function isPlaceholderUscfId(value?: string | null): boolean {
    return !!value && String(value).trim().toUpperCase().startsWith(SYNTHETIC_USCF_PREFIX);
}

/** A US Chess ID for display: blanks synthetic placeholders so they read as "no USCF". */
export function displayUscfId(value?: string | null): string {
    if (!value || isPlaceholderUscfId(value)) return '';
    return String(value).trim();
}

export function isPWAInstalled() {
    if (typeof window === 'undefined') return false;
    return (
        window.matchMedia?.('(display-mode: standalone)')?.matches ||
        (window.navigator as any)?.standalone ||
        document.referrer?.includes?.('android-app://')
    );
}

/** PWA or mobile viewport — use player-app home on tenant sites instead of marketing landing. */
export function shouldUsePlayerAppEntry() {
    if (typeof window === 'undefined') return false;
    return isPWAInstalled() || window.innerWidth < 1024;
}
